// redux/rootSaga.ts

import { all } from 'redux-saga/effects';

import { watchAccessGroupsSaga } from './accessGroups/accessGroupsSaga';
import watchAuditSaga from './audit/auditSaga';
import watchCardsSaga from './cards/cardsSaga';
import watchCardtimesSaga from './cardtimes/cardtimesSaga';
import watchClientConfigurationSaga from './clientConfiguration/clientConfigurationSaga';
import { watchCommentsSaga } from './comments/commentsSaga';
import watchContractsSaga from './contracts/contractsSaga';
import watchContractsDetailsSaga from './contractsDetails/contractsDetailsSaga';
import watchCustomersSaga from './customers/customersSaga';
import watchDestPointSaga from './destPoint/destPointSaga';
import watchDestPointDetailsSaga from './destPointDetails/destPointDetailsSaga';
import watchDriversSaga from './drivers/driversSaga';
import watchDynamicTablesSaga from './dynamicTables/dynamicTablesSaga';
import { watchHistorySaga } from './history/historySaga';
import { watchIdentitySaga } from './identity/identitySaga';
import watchInventorizationSaga from './inventorization/inventorizationSaga';
import watchIotSaga from './iot/iotSaga';
import { watchIVAZSaga } from './ivaz/ivazSaga';
import watchLicensesSaga from './licenses/licensesSaga';
import watchOrdersSaga from './orders/ordersSaga';
import watchProductsSaga from './products/productsSaga';
import watchProductsGroupsSaga from './productsGroups/productsGroupsSaga';
import { watchReportsSaga } from './reports/reportsSaga';
import watchRequestedMsgSaga from './requestedMsg/requestedMsgSaga';
import watchResultsaga from './results/resultsSaga';
import watchSettingsSaga from './settings/settingsSaga';
import watchSpySaga from './spy/spySaga';
import watchTaskSchedulerSaga from './taskScheduler/taskSchedulerSaga';
import { watchToastSaga } from './toast/toastSaga';
import { watchUsersSaga } from './users/usersSaga';
import watchVehiclesSaga from './vehicles/vehiclesSaga';
import watchWarehouseSaga from './warehouse/warehouseSaga';
import watchWeightingsSaga from './weightings/weightingsSaga';

export default function* rootSaga() {
	yield all([
		watchIdentitySaga(),
		watchUsersSaga(),
		watchAccessGroupsSaga(),
		watchResultsaga(),
		watchToastSaga(),
		watchClientConfigurationSaga(),
		watchReportsSaga(),
		watchCommentsSaga(),
		watchIVAZSaga(),
		watchHistorySaga(),
		watchCustomersSaga(),
		watchOrdersSaga(),
		watchDriversSaga(),
		watchVehiclesSaga(),
		watchWeightingsSaga(),
		watchProductsSaga(),
		watchProductsGroupsSaga(),
		watchContractsSaga(),
		watchContractsDetailsSaga(),
		watchSpySaga(),
		watchDestPointSaga(),
		watchDestPointDetailsSaga(),
		watchCardsSaga(),
		watchCardtimesSaga(),
		watchSettingsSaga(),
		watchLicensesSaga(),
		watchAuditSaga(),
		watchWarehouseSaga(),
		watchInventorizationSaga(),
		watchIotSaga(),
		watchDynamicTablesSaga(),
		watchTaskSchedulerSaga(),
		watchRequestedMsgSaga(),
	]);
}
